import tiktokIcon from 'images/social-tiktok.svg';

import type { FooterSocialLink } from './Footer';

export const FOOTER_SOCIAL_LINKS: FooterSocialLink[] = [
    { labelKey: 'Facebook', href: 'https://www.facebook.com/share/18hrR8ea1y/?mibextid=wwXIfr', iconName: 'facebook' },
    { labelKey: 'LinkedIn', href: 'https://www.linkedin.com/showcase/metadefender-cloud/', iconName: 'linkedin' },
    { labelKey: 'X', href: 'https://x.com/MetaDefenderCLD', iconName: 'x' },
    { labelKey: 'Instagram', href: 'https://www.instagram.com/metadefendercloud/', iconName: 'instagram' },
    { labelKey: 'TikTok', href: 'https://www.tiktok.com/@metadefendercloud', imgSrc: tiktokIcon },
    { labelKey: 'YouTube', href: 'https://www.youtube.com/@MetaDefenderCloud', iconName: 'youtube' },
];
